import { Component } from '@angular/core';
import {
	UntypedFormControl,
	Validators,
	FormsModule,
	ReactiveFormsModule,
} from '@angular/forms';
import {
	MatDialog,
	MatDialogRef,
	MatDialogTitle,
	MatDialogContent,
	MatDialogActions,
	MatDialogClose,
} from '@angular/material/dialog';
import { APIError, ApiService } from 'src/app/services/api.services';
import { AuthService } from 'src/app/services/auth.service';
import { AppDialogComponent } from 'src/app/components/app-dialog/app-dialog.component';
import { lastValueFrom } from 'rxjs';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatFormField, MatLabel, MatError } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { PasswordValidationComponent } from '../password-validation/password-validation.component';
import { MatButton } from '@angular/material/button';

@Component({
	selector: 'app-change-password',
	templateUrl: './change-password.component.html',
	styleUrls: [
		'./change-password.component.css',
		'../../ui/common/modal.scss',
		'../../ui/common/main.scss',
	],
	imports: [
		MatDialogTitle,
		CdkScrollable,
		MatDialogContent,
		FormsModule,
		MatFormField,
		MatLabel,
		MatInput,
		ReactiveFormsModule,
		MatError,
		PasswordValidationComponent,
		MatDialogActions,
		MatButton,
		MatDialogClose,
	],
})
export class ChangePasswordComponent {
	oldPasswordFormControl = new UntypedFormControl('', [Validators.required]);
	passwordFormControl = new UntypedFormControl('', [Validators.required]);
	confirmPasswordFormControl = new UntypedFormControl('', [
		Validators.required,
	]);

	constructor(
		private dialog: MatDialog,
		private dialogRef: MatDialogRef<ChangePasswordComponent>,
		private apiService: ApiService,
		private auth: AuthService
	) {}

	submitChangePassword(): void {
		const oldPassword = this.oldPasswordFormControl.value;
		const newPassword = this.passwordFormControl.value;
		if (oldPassword !== '') {
			this.apiService
				.changePassword(oldPassword, newPassword)
				.then(() => {
					lastValueFrom(
						this.dialog
							.open(AppDialogComponent, {
								data: {
									title: 'Success',
									message:
										'Your password has been successfully updated. You must login again with your new password.',
								},
							})
							.afterClosed()
					).then(() => {
						// Logout and force user to login again
						this.dialogRef.close();
						this.auth.logout();
					});
				})
				.catch((error) => {
					const apiError = error as APIError;
					const title = apiError.errors[0]?.title ?? 'Error';
					const message = apiError.errors[0]?.detail ?? 'Internal server error';
					this.dialog.open(AppDialogComponent, {
						data: { title, message },
					});
				});
		} else {
			this.dialog.open(AppDialogComponent, {
				data: {
					title: 'Error',
					message: 'You must enter your old password to change your password',
				},
			});
		}
	}
}
